class NotificationsMiddleware {
}

export default new NotificationsMiddleware()
